import { render, staticRenderFns } from "./phone_edit.vue?vue&type=template&id=60c0498a&"
import script from "./phone_edit.vue?vue&type=script&lang=ts&"
export * from "./phone_edit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports